import * as PIXI from "pixi.js";
import Photo from "./photo";
import PhotoL from "./photo_l";
import { DotFilter } from "pixi-filters";

export default class Canvas {
    constructor() {
        this.app = null;
        this.photos = [];
        this.photosL = [];
        this.container = null;
        this.loadRatio = window.innerWidth / window.innerHeight;
        this.loadedResources = null;
        this.resizeTimer = null;
        this.init();
    }

    init() {
        this.setupPixi();
        this.eventBind();
    }

    setupPixi() {
        //webGLが有効ならば
        if (PIXI.utils.isWebGLSupported()) {
            this.app = new PIXI.Application({
                view: document.querySelector(".js-canvas"),
                transparent: true,
            });

            this.setFullscreenCanvas();
            this.setLoader();
        } else {
            //サポート外では代替画像を表示
            document.body.classList.add("-no_webgl");
        }
    }

    factory(resources) {
        const photos = this.photos;
        const photosL = this.photosL; //倍角画像

        //横枚数12枚×高さ方向数
        const imgh = (window.innerWidth / 10) * 0.5625;
        const amount_wide = Math.ceil(window.innerHeight / imgh) * 12;
        const amount = window.innerWidth <= 768 ? 80 : amount_wide;
        this.container = new PIXI.Container();

        //通常グリッド
        for (let i = 0; i < amount; i++) {
            const photo = new Photo(i, resources);
            photos.push(photo);
            this.container.addChild(photo.g);
        }

        const ab = window.innerWidth <= 768 ? 5 : amount_wide / 10;

        //倍角グリッド
        for (let i = 0; i < ab; i++) {
            const photoL = new PhotoL(i, resources);
            photosL.push(photoL);
            this.container.addChild(photoL.g);
        }

        this.app.stage.addChild(this.container);
    }

    refactory() {
        //アス比が横長→縦になった際枚数がたりなくなるので、
        //再生成させる
        this.app.stage.removeChild(this.container);
        this.container = null;
        this.photos = [];
        this.photosL = [];
        this.factory(this.loadedResources);
        //console.log("refactory");
    }

    setLoader() {
        const loader = new PIXI.Loader();

        //ロード完了
        loader.onComplete.add(() => {
            console.log("Load:complete");
        });

        loader.add([{ name: "sprite", url: "./assets/img/top/mainvisual/screen/sprite.json" }]).load((loader, resources) => {
            const fps = 60;
            let now = performance.now();
            let start = 0;

            this.factory(resources);
            this.loadedResources = resources; //読み込み済みリソースを格納

            let animate = (timestamp) => {
                if (start === 0) {
                    start = timestamp;
                }

                let elapsed = (timestamp - start) / 1000;

                this.photos.forEach((photo) => photo.update(elapsed));
                this.photosL.forEach((photo) => photo.update(elapsed));

                //表示
                this.photos.forEach((photo) => photo.display());
                this.photosL.forEach((photo) => photo.display());
                now = timestamp;

                requestAnimationFrame(animate);
            };

            animate(performance.now());

            let filswitch = null;

            const loop = () => {
                if (filswitch === null) {
                    filswitch = 1;
                    document.querySelector(".mainvisual__curtain").classList.add("-animate");

                    setTimeout(() => {
                        document.querySelector(".mainvisual__curtain").classList.remove("-animate");
                    }, 2000);

                    setTimeout(() => {
                        if (window.innerWidth <= 768) {
                            this.container.scale.x = this.container.scale.y = 1.5;
                        } else {
                            this.container.scale.x = this.container.scale.y = 1.5;
                        }

                        //モアレ防止のため、devicePixelratioを計算に入れる
                        this.container.filters = [new DotFilter(0.9 / window.devicePixelRatio, 5)];
                        this.container.rotation = -(10 * Math.PI) / 180;
                    }, 500);
                } else {
                    filswitch = null;
                    document.querySelector(".mainvisual__curtain").classList.add("-animate");
                    setTimeout(() => {
                        document.querySelector(".mainvisual__curtain").classList.remove("-animate");
                    }, 2000);

                    setTimeout(() => {
                        this.container.filters = null;
                        this.container.rotation = 0;
                        this.container.scale.x = this.container.scale.y = 1;
                    }, 500);
                }
                setTimeout(loop, 5000);
            };

            setTimeout(loop, 2000);
        });
    }

    eventBind() {
        window.addEventListener("resize", this.setFullscreenCanvas.bind(this));
    }

    setFullscreenCanvas() {
        //リサイズイベントがスクロールで連続で発生しないようにする
        clearTimeout(this.resizeTimer);
        const photos = this.photos;
        const photosL = this.photosL;

        //ロード→リサイズ時にアス比率が縦長になった場合
        const ratio = window.innerWidth / window.innerHeight;
        const changeRatio = this.loadRatio - ratio;

        //console.log(ratio, changeRatio);

        this.resizeTimer = setTimeout(() => {
            //ratio,canvasサイズ、描画領域を再計算
            this.app.renderer.resize(window.innerWidth * window.devicePixelRatio, window.innerHeight * window.devicePixelRatio);
            this.app.view.style.width = window.innerWidth + "px";
            this.app.view.style.height = window.innerHeight + "px";
            photos.forEach((photo) => photo.remap());
            photosL.forEach((photo) => photo.remap());

            //リサイズ時の比率変化が縦長になってしまうとき再生成;
            if (changeRatio >= 0.35) {
                this.loadRatio = ratio; //何回も再生成されないように更新
                this.refactory();
            } else if (this.loadRatio <= 1 && changeRatio <= -0.5) {
                //スマホ比率から横長
                this.loadRatio = ratio;
                this.refactory();
            }
        }, 100);
    }
}
